import { get, post, request } from "../request";
const mock = "";

// 绑定设备
export const bindDevice = (params) => post(`/v1/user/device/bindOrg`, params);
// 获取设备列表
export const getDeviceList = (params) => get(`/v1/user/device/list`, params);

// 获取机构的设备配置
export const getOrgDeviceConfig = (params) =>
  get(`/v1/user/device/orgConfig`, params);
// 移除设备
export const removeDevice = (params) => post(`/v1/user/device/remove`, params);

//  学生的机构列表
export const getStudentOrgList = (params) =>
  get(`/v1/user/device/orgList`, params);

// 保存设备网络状态
export const saveNetwork = (params) => {
  return request(`${mock}/v1/user/device/saveNetwork`, "post", {
    json: params,
  });
};
